import "./LoginMobileView.scss";

const LoginMobileView = ({
    logo_svg,
    email,
    password,
    errorMsg,
    onEmailChange,
    onPasswordChange,
    onSubmit
}) => {
    return (
        <>

            <div className='login-mobile-view'>
                <div className='mobile-view-dynamic-island'>
                </div>
                <div className='login-mobile-view-container'>
                    <div className='login-mobile-view-container-logo'>
                        <img className='login-logo' src={logo_svg} alt="logo" />
                        <div className='login-mobile-view-container-logo-title'>noccarc</div>
                    </div>
                    <div className='login-mobile-view-container-inputs'>
                        <div className='login-mobile-view-container-inputs-title'>Sign In</div>
                        <div className='login-mobile-view-container-inputs-container'>
                            {/* <div className='email-container'> */}
                            <input
                                className='login-input email'
                                type='email'
                                placeholder='Email ID'
                                value={email || ""}
                                onChange={onEmailChange}
                            />
                            {/* </div> */}

                            {/* <div className='password-container'> */}
                            <input
                                className='login-input password'
                                type="password"
                                placeholder='Password'
                                value={password || ""}
                                onChange={onPasswordChange}
                            />
                            {/* </div> */}

                            <div className='error-msg'>
                                {errorMsg}
                            </div>
                        </div>



                    </div>
                    <div className='login-mobile-view-container-sign-in'>
                            <button
                                className='sign-in sign-in-botton'
                                onClick={onSubmit}
                            >
                                Sign In
                            </button>
                    </div>
                </div>

            </div>

        </>
    );
};

export default LoginMobileView;
